import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import loadOpportunities from '../service/opportunityApi';
const PAGE_META = {
  '/jobs': {
    title: 'Вакансии для разработчиков',
    type: 'job',
    events: false
  },
  '/projects': {
    title: 'Проекты и сотрудничество',
    type: 'project',
    events: false
  },
  '/events': {
    title: 'События сообщества',
    type: null,
    events: true
  }
};
export default class OpportunitiesPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.meta = PAGE_META[window.location.pathname] || PAGE_META['/jobs'];
    this.items = [];
    this.loading = true;
    loadOpportunities(this.meta.type).then(response => {
      const data = response.data || {};
      this.items = this.meta.events ? data.events || [] : data.opportunities || [];
    }).catch(() => {
      this.items = [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(this.meta.title);
  }
  view() {
    return m('main.dc-opportunities', {
      'aria-labelledby': 'dc-opportunities-title'
    }, [m('section.dc-opportunities__hero', m('div.dc-container', [m('span', 'Возможности DevConnect'), m('h1#dc-opportunities-title', this.meta.title), m('p', this.meta.events ? 'Встречи, разборы и мастер-классы, где можно задать вопросы практикам.' : 'Публикуем только предложения с понятной задачей, условиями и прямым способом отклика.'), m('nav', [m('a', {
      href: '/jobs'
    }, 'Вакансии'), m('a', {
      href: '/projects'
    }, 'Проекты'), m('a', {
      href: '/events'
    }, 'События')])])), m('section.dc-container.dc-opportunities__list', this.content())]);
  }
  content() {
    if (this.loading) {
      return m('div.dc-opportunities__empty', [m('h2', 'Загружаем предложения…')]);
    }
    if (!this.items.length) {
      return m('div.dc-opportunities__empty', [m('h2', 'Сейчас активных предложений нет'), m('p', 'Новые публикации появятся после проверки редакцией.')]);
    }

    // События и предложения имеют разные контракты, поэтому их карточки разделены на самостоятельные методы.
    return this.items.map(item => this.meta.events ? this.eventCard(item) : this.opportunityCard(item));
  }
  eventCard(item) {
    const startsAt = new Date(item.startsAt);
    const day = new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit'
    }).format(startsAt);
    const month = new Intl.DateTimeFormat('ru-RU', {
      month: 'short'
    }).format(startsAt);
    const fullDate = new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: 'long',
      hour: '2-digit',
      minute: '2-digit'
    }).format(startsAt);
    return m('article.dc-opportunity-card', [m('div.dc-opportunity-card__date', [m('b', day), m('span', month)]), m('div', [m('span.dc-opportunity-card__type', item.format), m('h2', item.title), m('p', item.summary), m('footer', [m('span', `${fullDate} · ${item.location}`), m('a', {
      href: item.registrationUrl,
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    }, 'Зарегистрироваться ↗')])])]);
  }
  opportunityCard(item) {
    return m('article.dc-opportunity-card', [m('div.dc-opportunity-card__logo', (item.company || item.title || '?').slice(0, 1).toLocaleUpperCase('ru-RU')), m('div', [m('span.dc-opportunity-card__type', item.typeLabel), m('h2', item.title), m('p.dc-opportunity-card__company', `${item.company} · ${item.workMode} · ${item.location}`), m('p', item.summary), m('div.dc-opportunity-card__skills', (item.skills || []).map(skill => m('span', skill))), m('footer', [m('b', item.compensation || 'По договорённости'), m('a', {
      href: item.applyUrl,
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    }, 'Откликнуться ↗')])])]);
  }
}
flarum.reg.add('devconnect-jobs', 'forum/components/OpportunitiesPage', OpportunitiesPage);